export default __webpack_public_path__ + "static/media/icon-menu-order-active.fc7e8485.svg";